<template>
  <ul
    class="tgbContextMenu"
    :style="menuStyles"
    @contextmenu.stop
  >
    <li
      v-for="action in actions"
      :key="action.key"
      class="tgbContextMenuItem"
    >
      <slot v-bind="action" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TgbContextMenu',
  props: {
    actions: Array,
    dropDownMenu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      top: '0px',
      left: '0px',
      position: 'fixed',
    };
  },

  computed: {
    menuStyles() {
      const { top, left, position } = this;

      return {
        top: position === 'fixed' ? `calc(${top} + 1rem)` : top,
        left,
        position,
      };
    },
  },

  watch: {
    dropDownMenu: {
      immediate: true,
      handler(options) {
        this.$nextTick(() => {
          if (options) {
            this.position = 'relative';
            return;
          }

          this.$el.focus();
          this.setMenu(event.clientY, event.clientX); // eslint-disable-line
        });
      },
    },
  },

  methods: {
    setMenu(top, left) {
      let newTop = top;
      let newLeft = left;
      const largestHeight = window.innerHeight - this.$el.offsetHeight - 25;
      const largestWidth = window.innerWidth - this.$el.offsetWidth - 25;

      if (top > largestHeight) newTop = largestHeight;
      if (left > largestWidth) newLeft = largestWidth;

      this.top = `${newTop}px`;
      this.left = `${newLeft}px`;
    },
  },
};
</script>

<style lang="scss">
.tgbContextMenu {
  background: #1d1d1d;//surface/menu/default
  //todo: ask Jennifer is there a global box shadow?
  box-shadow: 4px 4px 4px 1px rgba(0, 0, 0, 0.5);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: fixed;
  min-width: 200px;
  max-width: 500px;
  z-index: 2;
}
  .tgbContextMenuItem {
    // padding: 16px 32px;
    color: white;

    &:hover,
    &:focus {
      // background: #182629; /* Surface/Menu/Hover */
      background: #2e2e2e // to match the old theme
    }

    &:active {
      // background: #182629; /* Surface/Menu/Hover */
      background: #2e2e2e // to match the old theme
    }
  }
  .tgbContextMenuButton {
    padding: 16px 32px;
    color: inherit;
    width: 100%;

     @at-root {
      button#{&} {
        background: transparent;
        border: none;
        text-align: left;
        font-size: 13px;
      }
      a#{&} {
        display: inline-block;

        &:hover,
        &:focus,
        &:active {
          color: inherit;
        }
      }
    }
  }
</style>
